import { ADMIN_DEMO_STORAGE_KEY } from "./adminDemoSelections";

function loadStore(): Record<string, unknown> {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(ADMIN_DEMO_STORAGE_KEY);
    if (raw == null) return {};
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return {};
  }
}

function persistStore(store: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(ADMIN_DEMO_STORAGE_KEY, JSON.stringify(store));
  } catch {
    // best-effort
  }
}

export function hasDemoField(field: string): boolean {
  return loadStore()[field] !== undefined;
}

export function loadDemoAgents<T extends { id: string }>(
  field: string,
  fallback: T[],
): T[] {
  const value = loadDemoField<unknown>(field, null);
  if (!Array.isArray(value)) return fallback;
  const isAgentLike = (item: unknown): item is T =>
    typeof item === "object" && item != null && "id" in item;
  return value.every(isAgentLike) ? (value as T[]) : fallback;
}

export function loadDemoField<T>(field: string, fallback: T): T {
  const value = loadStore()[field];
  if (value === undefined) return fallback;
  return value as T;
}

export function removeDemoField(field: string): void {
  const store = loadStore();
  delete store[field];
  persistStore(store);
}

export function saveDemoField(field: string, value: unknown): void {
  const store = loadStore();
  store[field] = value;
  persistStore(store);
}
